<script>
import { mergeData } from 'vue-functional-data-merge';

export default {
  name: 'ClickArea',
  functional: true,
  props: {
    item: {
      required: true,
      validator: (item) => {
        if (!item) return true;
        const oneOfThemFields = ['routerLink', 'externalLink', 'action'];
        return oneOfThemFields.some((val) => val in item);
      },
    },
  },
  render (h, ctx) {
    const {
      item,
    } = ctx.props;
    if (!item) return ctx.children;
    const {
      routerLink,
      externalLink,
      action,
      children,
    } = item;
    const customData = data => mergeData(ctx.data, data);
    if (routerLink || children) {
      return h('router-link', customData({
        props: {
          to: routerLink,
          activeClass: '-active',
          event: children ? '' : 'click',
        },
        nativeOn: ctx.listeners,
      }), ctx.children);
    } else if (externalLink) {
      return h('a', customData({
        attrs: {
          href: externalLink,
          rel: 'noopener',
          target: '_blank',
        },
      }), ctx.children);
    } else if (action) {
      return h('div', customData({
        on: {
          click: () => action(),
        },
      }), ctx.children);
    }
    return ctx.children;
  },
};
</script>
